import { useUser } from '@/modules/common/application/context/user';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';

import { getStackholderLabel } from 'src/modules/common/application/user';
import { User } from 'src/modules/common/types';
import theme from 'src/styles/theme';

const HomeWelcomeMessage = () => {
  const { t } = useTranslation();
  const { user } = useUser();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Typography variant="body1" color={theme.palette.colors.lightGrey}>
        {t('modules.home.personalizedTitle', {
          name: getStackholderLabel(user as User),
        })}
      </Typography>
    </Box>
  );
};

export default HomeWelcomeMessage;
